import IconButton from "./IconButton";
import React from "react";
import {useHistory} from "react-router-dom";

export function LinkIconButton({icon, tooltip, link, props, disabled, model}) {
    const history = useHistory()

    return <IconButton
        tooltip={model?.title || tooltip}
        icon={model?.icon || icon}
        disabled={disabled}
        variant={"primary mr-2"}
        onClick={() => history.push(link || model?.url)}
    />;
}